define('controllers/enrollmentbonus',['require'],function (require) {
  return function () {
    var $saveBtn = $("#btnAddEnrollmentBonusOneTime");
    var $txtAmount = $("#txtAmount");

    $txtAmount.on("keyup", function (e) {
      var amount = $txtAmount.val();
      if (amount < 50 || amount > 2000) {
        $saveBtn.prop("disabled", true);
      } else {
        $saveBtn.prop("disabled", false);
      }
    });

    $("#btnAddEnrollmentBonusOneTime").on("click", function (e) {
      console.log(Page_ClientValidate());
      if (window.Page_ClientValidate == undefined || Page_ClientValidate()) {
        $(this).hide();
        $("#loading").fadeIn("slow");
      } else {
        e.preventDefault();
      }
    });

    Utilities.setDefaultButton(
      $("#pnlEnrollmentBonusForm"),
      $("#btnAddEnrollmentBonusOneTime"),
    );
  };
});

